import './App.css';
import Home from './pages/Home';
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate
} from 'react-router-dom';
import SingleEmployee from './pages/SingleEmployee';
import AllUser from './pages/users';
import Layout from './Layout';
import { useSelector } from 'react-redux';
import LoginPage from './pages/LoginPage';
import EmpSummary from './components/EmployeeSummary/AttdSummary';
import { useState } from 'react';
import Employee from './pages/employee';
import MarkAttendance from './pages/MarkAttendance';
import Department from './pages/department';
import WorkSheet from './pages/WorkSheet';
import Holiday from './pages/Holiday';
import SickLeaves from './pages/SickLeaves';
import AnnualLeaves from './pages/AnnualLeaves';
import TodayAttendence from './pages/todayAttendence';
import AdminDashboard from './pages/adminDashboard';
import MonthlyEmployeeReport from './pages/monthlyEmpReport';
import IndividualPayslipPage from './pages/IndividualPayslipPage';
import TaskPage from './pages/TaskPage';

import './styles/LoginRings.css'
import Payslip from './pages/payslip';
import Designations from './components/Designation';
import ReportPayslipPage from './pages/ReportPayslipPage';
import NotFound from './utils/NotFound';
import EmployeeLeavePage from './pages/EmployeeLeavePage';
import PayslipStructure from './pages/payslipStructure';
import HourlyEmployeeReport from './pages/HourlyEmployeeReport';
import LateAttReport from './pages/LateAttReport';
import EmailTemplate from './pages/emailTemplate';
import AutoLogout from './components/auth/Autologout';
import TaskOverview from './components/TaskOverview';
import ProtectedRoute from './utils/ProtectedRoute';
import UserControl from './pages/userControl';
import PendingOuts from './pages/pendingOuts';
import UnauthorizedPage from './pages/unauthorized';
import AttendanceRecord from './pages/AttRecord';
import EmpTask from './pages/empTask';
function App() {
  const { users } = useSelector((state) => state.user || {})
  // console.log("users--->>>",users?.ROLE_TITLE != "HR" || "Admin" )
  // console.log("cuureentusers--->>>",users )
  const [name, setName] = useState('')
  return (
    <BrowserRouter>
      <AutoLogout>
        <Routes>
          <Route path='/unauthorized' element={ users ? <UnauthorizedPage /> :  <Navigate to='/login' />}  />
          <Route path='/login' element={users ? <Navigate to='/' replace/> : <LoginPage />} />
          <Route path='/AttendanceSheet' element={<ProtectedRoute page="Attendance Sheet">  <SingleEmployee name={name} />        </ProtectedRoute>} />
          <Route path='/AttendanceRecords' element={<ProtectedRoute page="Attendance Records">  <AttendanceRecord name={name} />        </ProtectedRoute>} />
          <Route path='/MonthlyReport' element={<ProtectedRoute page="Monthly Report">  <MonthlyEmployeeReport name={name} /> </ProtectedRoute>} />
          <Route path='/EarlyExitReport' element={<ProtectedRoute page="Early Exit Report">  <HourlyEmployeeReport name={name} />  </ProtectedRoute>} />
          <Route path='/LateAttendanceReport' element={<ProtectedRoute page="Late Attendance Report">  <LateAttReport name={name} />         </ProtectedRoute>} />
          <Route path="/" element={<Layout setName={setName} />}>
            {/* Home Page Route  */}
            { users?.ROLE_TITLE === "Client" ? 
              <Route
                index
                element={
                  <ProtectedRoute page="Today Attendance">
                    {users?.ROLE_TITLE === "Client" ? <Home /> : <AdminDashboard />}
                  </ProtectedRoute>
                }
              /> : 
               <Route
                index
                element={
                  <ProtectedRoute page="Home">
                    {users?.ROLE_TITLE === "Client" ? <Home /> : <AdminDashboard />}
                  </ProtectedRoute>
                }
              />  

            }
            <Route path='/todayAttendence'     element={<ProtectedRoute page="Today Attendance">  <TodayAttendence /> </ProtectedRoute>} />
            <Route path='/allUser'             element={<ProtectedRoute page="Users">  <AllUser /> </ProtectedRoute>} />
            <Route path='/userControl'             element={<ProtectedRoute page="Users Control">  <UserControl /> </ProtectedRoute>} />
            <Route path='/emailTemplate'       element={<ProtectedRoute page="Employee Report Emails">  <EmailTemplate /> </ProtectedRoute>} />
            <Route path='/employee'            element={<ProtectedRoute page="Employees">  <Employee /> </ProtectedRoute>} />
            <Route path='/employeetask'            element={<ProtectedRoute page="Employee Task">  <EmpTask /> </ProtectedRoute>} />
            <Route path='/markatt'             element={<ProtectedRoute page="Mark Attendance">  <MarkAttendance /> </ProtectedRoute>} />
            <Route path='/department'          element={<ProtectedRoute page="Department">  <Department /> </ProtectedRoute>} />
            <Route path='/designation'         element={<ProtectedRoute page="Designation">  <Designations /> </ProtectedRoute>} />
            <Route path='/pendingOuts'             element={<ProtectedRoute page="Pending Out">  <PendingOuts/> </ProtectedRoute>} />
            <Route path='/payslip'             element={<ProtectedRoute page="PaySlip">  <Payslip /> </ProtectedRoute>} />
            <Route path='/payslipStructure'    element={<ProtectedRoute page="PaySlip Structure">  <PayslipStructure /> </ProtectedRoute>} />
            <Route path="/payslip/individualpayslip" element={<ProtectedRoute page="PaySlip"><IndividualPayslipPage /> </ProtectedRoute>} />
            <Route path="/payslip/report"            element={<ProtectedRoute page="PaySlip"><ReportPayslipPage /> </ProtectedRoute>} />
            <Route path='/worksheet'           element={<ProtectedRoute page="Worksheet">  <WorkSheet /> </ProtectedRoute>} />
            <Route path='/holiday'             element={<ProtectedRoute page="Holiday">  <Holiday /> </ProtectedRoute>} />
            <Route path='/sickleave'           element={<ProtectedRoute page="Add Leave">  <SickLeaves /> </ProtectedRoute>} />
            <Route path='/task'                element={<ProtectedRoute page="Tasks">  <TaskPage /> </ProtectedRoute>} />
            <Route path='/taskOverview'        element={<ProtectedRoute page="Task Overview">  <TaskOverview /> </ProtectedRoute>} />
            <Route path='/annualleave'         element={<ProtectedRoute page="Financial Year Leaves">  <AnnualLeaves /> </ProtectedRoute>} />
            <Route path='/leavedetail'         element={<ProtectedRoute page="Leaves Summary"> <EmployeeLeavePage /> </ProtectedRoute>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AutoLogout>
    </BrowserRouter>
  );
}

export default App;




